export default __webpack_public_path__ + "static/media/relative-book-pro.5d40e8b2.eot";